'use es6';

import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { setSeenNewFeatureShepherds as requestFn } from '../clients/newFeaturesClients';
import { UPDATE_SEEN_NEW_FEATURE_SHEPHERDS as actionTypes } from '../constants/asyncActionTypes';
export const updateSeenNewFeatureShepherds = createAsyncAction({
  requestFn,
  actionTypes,
  toRecordFn: response => response
});